import { Fieldset, Title, TextInput, Textarea, Select, Space } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';

import { paymentMethodConfirmationTypeList, paymentMethodConfirmationTypeTitles } from '../../utils/const/common';
import { countryCodes } from '../../utils/const/country-codes';

import type { UseFormReturnType } from '@mantine/form';
import type { ReactNode } from 'react';
import { TPaymentMethodConfimationType } from '../../store/types';

type Props<T> = {
  form: UseFormReturnType<T, (values: T) => T>;
  childrenOprions?: ReactNode;
  confirmationType: TPaymentMethodConfimationType;
};

export function CustomMethodFormFields<T>(props: Props<T>) {
  const {
    form,
    confirmationType,
    childrenOprions,
  } = props;

  return (
    <>
      <Title order={5}>Данные метода</Title>
      <Fieldset legend="Шаг 1 (выбор способа оплаты)" styles={{ root: { padding: '10px' } }}>
        <TextInput
          label="Заголовок выбора способа оплаты"
          placeholder="Выберите способ оплаты"
          withAsterisk
          key={form.key('data.step1.title')}
          {...form.getInputProps('data.step1.title')}
        />
        <Space h="sm" />
        {childrenOprions}
      </Fieldset>

      <Fieldset legend="Шаг 2 (совершение перевода)" styles={{ root: { padding: '10px' } }}>
        <TextInput
          label="Заголовок для совершения перевода"
          placeholder="Совершите перевод"
          withAsterisk
          key={form.key('data.step2.title')}
          {...form.getInputProps('data.step2.title')}
        />
        <Textarea
          label="Инструкции по шагам 1, 2, 3 (каждая с новой строки)"
          placeholder={`1. Откройте приложение.\n2. Скопируйте реквизиты.\n3. Сделайте перевод`}
          withAsterisk
          autosize
          minRows={3}
          key={form.key('data.step2.mainText')}
          {...form.getInputProps('data.step2.mainText')}
        />
      </Fieldset>

      <Fieldset legend="Шаг 3 (обработка платежа)" styles={{ root: { padding: '10px' } }}>
        <TextInput
          label="Заголовок обработки платежа"
          placeholder="Ваш платёж находится в обработке"
          withAsterisk
          key={form.key('data.step3.title')}
          {...form.getInputProps('data.step3.title')}
        />
      </Fieldset>

      <Fieldset legend="Подтверждение платежа" styles={{ root: { padding: '10px' } }}>
        <Select
          label="Тип подтверждения"
          withAsterisk
          data={paymentMethodConfirmationTypeList.map((type) => ({ value: type, label: paymentMethodConfirmationTypeTitles[type] }))}
          key={form.key('data.confirmation.type')}
          {...form.getInputProps('data.confirmation.type')}
        />
        {confirmationType === 'receipt' && (
          <TextInput
            label="Заголовок для загрузки файла"
            placeholder="Загрузите чек"
            withAsterisk={confirmationType === 'receipt' ? true : false}
            key={form.key('data.confirmation.fileText')}
            {...form.getInputProps('data.confirmation.fileText')}
          />
        )}
        <TextInput
          label="Заголовок для текстового поля"
          placeholder={confirmationType === 'receipt' ? 'Введите ваш номер телефона' : 'Введите хэш транзакции'}
          withAsterisk
          key={form.key('data.confirmation.additionalText')}
          {...form.getInputProps('data.confirmation.additionalText')}
        />
        <Select
          label="Выберите страну для отображения языка по умолчанию (также будет применяться для ввода номера телефона)"
          placeholder='Россия ( ru )'
          withAsterisk
          clearable
          searchable
          nothingFoundMessage="Ничего не найдено..."
          leftSection={<IconSearch size={16} />}
          limit={5}
          data={countryCodes.map((item) => ({ value: item.countryCode.toLowerCase(), label: `${item.country} ( ${item.countryCode.toLowerCase()} )` }))}
          key={form.key('data.confirmation.phoneCountry')}
          {...form.getInputProps('data.confirmation.phoneCountry')}
        />
      </Fieldset>
    </>
  );
};
